import { oteApi } from 'yxt-biz-pc/packages/api';

/**
 * 考试分析
 * @param {string} arrangeId 考试安排ID
 */
export const getArrangeAnalysis = (arrangeId, params, grouporgProjectCenter) => {
  return oteApi.get(`/arrange/${arrangeId}/analysis?oteGroupFuncReq=${grouporgProjectCenter ? 1 : 0}`, params);
};
